import { Component } from 'react';

import { FormControl, FormGroup } from '../../../models/forms';
import { Logger } from '../../../models/logger';
import styles from './url-encode.component.module.scss';
import sharedStyles from '../single-page.module.scss';
import { FullscreenHost } from '../fullscreen-host.component';


const URL_ENCODE = 'URL_ENCODE';
const QUERY_ENCODE = 'QUERY_ENCODE';

export class URLEncodeComponent extends Component {
    private readonly logger = Logger.getLogger('URLEncodeComponent');

    form = new FormGroup({
        mode: new FormControl(QUERY_ENCODE),
        textinput: new FormControl(''),
        reverseTextinput: new FormControl(''),
    });

    componentDidMount() {
        this.form.get('mode').valueChanges.subscribe(
            (data) => {
                let value = '';
                try {
                    if (data === URL_ENCODE) {
                        value = this.encodeURIComponent(this.form.get('textinput').value);
                    } else {
                        value = this.encodeURI(this.form.get('textinput').value);
                    }
                } catch (e) {
                    value = 'Error: Unable to encode content.';
                }
                this.form.get('reverseTextinput').setValue(value, { noEmit: true });
                this.forceUpdate();
            },
            (err) => this.logger.error(err),
        );

        this.form.get('textinput').valueChanges.subscribe(
            (data) => {
                let value = '';
                try {
                    if (this.form.get('mode').value === URL_ENCODE) {
                        value = this.encodeURIComponent(data);
                    } else {
                        value = this.encodeURI(data);
                    }
                } catch (e) {
                    value = 'Error: Unable to encode content.';
                }
                this.form.get('reverseTextinput').setValue(value, { noEmit: true });
                this.forceUpdate();
            },
            (err) => this.logger.error(err),
        );

        this.form.get('reverseTextinput').valueChanges.subscribe(
            (data) => {
                let value = '';
                try {
                    if (this.form.get('mode').value === URL_ENCODE) {
                        value = this.decodeURIComponent(data);
                    } else {
                        value = this.decodeURI(data);
                    }
                } catch (e) {
                    // Do nothing or show error in input? 
                    // Usually we don't update the input if reverse decoding fails to avoid overwriting user's input with error message
                    // But we should probably log it.
                    // For reverse input (Output textarea), if user types there, we update the main input. 
                    // If it fails, maybe we shouldn't update the main input to an error string.
                    return;
                }
                this.form.get('textinput').setValue(value, { noEmit: true });
                this.forceUpdate();
            },
            (err) => this.logger.error(err),
        );
    }

    encodeURIComponent(toEncodeString) {
        return encodeURIComponent(toEncodeString).replace(/'/g, '%27').replace(/"/g, '%22');
    }

    encodeURI(toEncodeString) {
        return encodeURI(toEncodeString);
    }

    decodeURIComponent(toEncodeString) {
        return decodeURIComponent(toEncodeString).replace(/'/g, '%27').replace(/"/g, '%22');
    }

    decodeURI(toEncodeString) {
        return decodeURI(toEncodeString);
    }

    setRadioInputValue(ctrl: FormControl, value: any) {
        ctrl.setValue(value);
    }

    render() {
        return (<FullscreenHost><div className="row">
            <div className="col-12">
                <label className={sharedStyles.label}>Input</label>
                <textarea className={sharedStyles.textarea}
                    placeholder="Enter text to encode..."
                    value={this.form.controls['textinput'].value}
                    onInput={(e: any) => this.form.controls['textinput'].setValue(e.target.value)} rows={6}></textarea>
            </div>

            <div className="col-12">
                <div className={sharedStyles.controls}>
                    <div className={sharedStyles.radioGroup}>
                        <label className={sharedStyles.radioLabel}>
                            <input type="radio"
                                onChange={(e: any) => this.setRadioInputValue(this.form.controls['mode'], e.target.value)}
                                name="mode"
                                value={QUERY_ENCODE}
                                checked={this.form.controls['mode'].value === QUERY_ENCODE} />
                            URL Encode (Default)
                        </label>
                        <label className={sharedStyles.radioLabel}>
                            <input type="radio"
                                onChange={(e: any) => this.setRadioInputValue(this.form.controls['mode'], e.target.value)}
                                name="mode"
                                value={URL_ENCODE}
                                checked={this.form.controls['mode'].value === URL_ENCODE} />
                            URL Query Encode
                        </label>
                    </div>
                </div>
            </div>

            <div className="col-12">
                <label className={sharedStyles.label}>Output</label>
                <textarea className={sharedStyles.textarea}
                    placeholder="Result will appear here..."
                    value={this.form.controls['reverseTextinput'].value}
                    readOnly
                    rows={6}></textarea>
            </div>
        </div ></FullscreenHost>);}
}
